import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';

import * as styles from './NewsletterCTA.module.scss';

interface NewsletterCTAProps {
  className?: string;
  onCloseClick: () => void;
  onSubscribeClick: () => void;
}

const NewsletterCTA = ({
  className,
  onCloseClick,
  onSubscribeClick,
}: NewsletterCTAProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles.newsletterCta + ' ' + className}>
      <FaTimes className={styles.closeTag} onClick={onCloseClick} />
      <div className={styles.contentContainer}>
        <span className={styles.title}>{t('newsletter_cta.title', 'Newsletter')}</span>
        <p className={styles.text}>
          {t('newsletter_cta.text', "Subscribe our newsletter and don't miss any news.")}
        </p>
        <button className={styles.subscribeButton} onClick={onSubscribeClick}>
          {t('newsletter_cta.button', 'Subscribe')}
        </button>
      </div>
    </div>
  );
};

export default NewsletterCTA;
